import { render, staticRenderFns } from "./DataStudents.vue?vue&type=template&id=f8f3cfe6&scoped=true&"
import script from "./DataStudents.vue?vue&type=script&lang=js&"
export * from "./DataStudents.vue?vue&type=script&lang=js&"
import style0 from "./DataStudents.vue?vue&type=style&index=0&id=f8f3cfe6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f3cfe6",
  null
  
)

export default component.exports